var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeave1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.89 3.45H9.11001C8.71001 3.45 8.39001 3.13 8.39001 2.73C8.39001 2.33 8.71001 2 9.11001 2H14.89C15.29 2 15.61 2.32 15.61 2.72C15.61 3.12 15.29 3.45 14.89 3.45Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.9699V17.0299C14 15.2199 15.22 13.9999 17.03 13.9999H19.97C20.2 13.9999 20.42 14.0199 20.63 14.0599C20.65 13.8199 20.67 13.5799 20.67 13.3299C20.67 8.5399 16.78 4.6499 12 4.6499C7.22002 4.6499 3.33002 8.5399 3.33002 13.3299C3.33002 18.1099 7.22002 21.9999 12 21.9999C12.85 21.9999 13.66 21.8599 14.44 21.6399C14.16 21.1699 14 20.6099 14 19.9699ZM12.75 12.9999C12.75 13.4099 12.41 13.7499 12 13.7499C11.59 13.7499 11.25 13.4099 11.25 12.9999V7.9999C11.25 7.5899 11.59 7.2499 12 7.2499C12.41 7.2499 12.75 7.5899 12.75 7.9999V12.9999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.97 15H17.04C15.76 15 15 15.76 15 17.03V19.97C15 21.24 15.76 22 17.04 22H19.97C21.24 22 22 21.24 22 19.97V17.03C22 15.76 21.24 15 19.97 15ZM17.92 20.06C17.92 20.38 17.66 20.64 17.33 20.64C17.01 20.64 16.75 20.38 16.75 20.06V16.94C16.75 16.62 17.01 16.36 17.33 16.36C17.66 16.36 17.92 16.62 17.92 16.94V20.06ZM20.25 20.06C20.25 20.38 19.99 20.64 19.67 20.64C19.35 20.64 19.08 20.38 19.08 20.06V16.94C19.08 16.62 19.35 16.36 19.67 16.36C19.99 16.36 20.25 16.62 20.25 16.94V20.06Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave1);
export default __webpack_public_path__ + "static/media/leave (1).56ac8ffc96e3f423c3bcc7ba45e57a99.svg";
export { ForwardRef as ReactComponent };